"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateBookingChannelSchema = exports.createBookingChannelSchema = exports.bookingChannelShape = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (Appointment Administration, Module 2 — Appointment Sources). */
exports.bookingChannelShape = {
    code: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(150),
    requiresAuthentication: zod_1.z.boolean().optional(),
    allowsSameDayBooking: zod_1.z.boolean().optional(),
    maxAdvanceBookingDays: zod_1.z.number().int().positive().max(365).optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createBookingChannelSchema = zod_1.z.object(exports.bookingChannelShape);
exports.updateBookingChannelSchema = zod_1.z.object(exports.bookingChannelShape).partial();
//# sourceMappingURL=booking-channel.schema.js.map